import React, { useCallback, useMemo } from 'react';
import { View } from 'react-native';
import Button from 'design-system/Button';
import Spacer from 'design-system/Spacer';
import BottomPanel from 'design-system/BottomPanel';
import useStyles from 'hooks/useStyles';
import { useAppSelector } from 'store/hooks';
import createStyleSheets from 'utils/createStyleSheets';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import InvestBuySellButton from './Button';
import { selectTradingAccount } from '../reducers/selectors';
import { useDepositToGIA } from '../hooks/useDepositToGIA';
import { blockInvestActionOnWeb } from '../webGate';
const StockScreenButtonCTAs = ({ assetId, canSell, recurringOrderFlow }) => {
    const navigation = useMainStackNavigation();
    const scrambled = useAppSelector((store) => store.utils.scrambled);
    const tradingAccountObj = useAppSelector(selectTradingAccount);
    const tradingAccount = tradingAccountObj?.account;
    const tradingBlockExpiryDate = tradingAccount?.tradingBlockExpiryDate;
    const { onDeposit } = useDepositToGIA('buy');
    const styles = useStyles(styleSet);
    const onTopUpPress = useCallback(() => {
        if (scrambled)
            return;
        if (blockInvestActionOnWeb('Add money'))
            return;
        if (tradingAccount?.broker === 'seccl') {
            onDeposit();
            return;
        }
        navigation.navigate('InvestSelectAccountToTopup');
    }, [navigation, onDeposit, scrambled, tradingAccount?.broker]);
    const recurringOrderBtn = useMemo(() => tradingAccount?.broker === 'alpaca' && (<>
          <Spacer.H8 />
          <InvestBuySellButton buy gray recurring assetId={assetId}/>
        </>), [assetId, tradingAccount?.broker]);
    if (tradingBlockExpiryDate) {
        return (<BottomPanel>
        <InvestBuySellButton sell assetId={assetId}/>
      </BottomPanel>);
    }
    if (recurringOrderFlow) {
        return (<BottomPanel>
        <InvestBuySellButton buy recurring assetId={assetId}/>
      </BottomPanel>);
    }
    if (tradingAccount?.availableToInvest?.value === 0) {
        return (<BottomPanel>
        {canSell ? (<>
            <View style={styles.row}>
              <InvestBuySellButton sell flex assetId={assetId}/>
              <Spacer w={8}/>
              <Button brand flex title="Buy" onPress={onTopUpPress} containerStyle={styles.noPaddingHorizontal}/>
            </View>
            {recurringOrderBtn}
          </>) : (<>
            <Button brand title="Buy" onPress={onTopUpPress}/>
            {recurringOrderBtn}
          </>)}
      </BottomPanel>);
    }
    return (<BottomPanel>
      {canSell ? (<>
          <View style={styles.row}>
            <InvestBuySellButton sell flex assetId={assetId}/>
            <Spacer w={8}/>
            <InvestBuySellButton buy flex assetId={assetId}/>
          </View>
          {recurringOrderBtn}
        </>) : (<>
          <InvestBuySellButton buy assetId={assetId}/>
          {recurringOrderBtn}
        </>)}
    </BottomPanel>);
};
export default React.memo(StockScreenButtonCTAs);
const styleSet = createStyleSheets(() => ({
    row: {
        flexDirection: 'row',
    },
    noPaddingHorizontal: {
        paddingHorizontal: 0,
    },
}));
